import React from 'react';
import {TabView} from '../../../components/tab/TabView';
import {CaseStudyActiveTable, CaseStudyCompletedTable} from './CaseStudyTable';
import {SearchFilter} from '../../../components/filter/Filters';
import {useFilter} from '../../../controllers/useFilter';

export const CaseStudyTabView = props => {
  const {route: {params} = {}} = props;
  const {onChangeFilter, searchValue} = useFilter({
    filterKey: 'caseStudyFilter',
    params,
    filter: {},
  });
  let tabs = {
    active: {
      label: 'Active',
      view: <CaseStudyActiveTable searchValue={searchValue} />,
    },
    completed: {
      label: 'Completed',
      view: <CaseStudyCompletedTable searchValue={searchValue} />,
    },
  };

  return (
    <TabView
      tabs={tabs}
      params={params}
      {...props}
      actions={[
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
      ]}
    />
  );
};
